// Spyglass (154): small pure helpers for the recordings bench, tested on
// their own. The transcript is ten-second lines; the player highlights the
// line the playhead is in and seeks to a clicked one.

export interface Line { at: number; text: string }

/** The index of the line the playhead is in, or -1 before the first. */
export function lineAt(lines: Line[], t: number): number {
  let i = -1;
  for (let k = 0; k < lines.length; k++) { if (lines[k]!.at <= t) i = k; else break; }
  return i;
}

/** 3:05, 1:02:09 — a duration for a card, never "NaN:NaN". */
export function clock(ms: number | null | undefined): string {
  const s = Number.isFinite(ms) ? Math.max(0, Math.round((ms as number) / 1000)) : 0;
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), r = s % 60;
  return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}` : `${m}:${String(r).padStart(2, '0')}`;
}

/** The transcript as one paragraph, for the copy button. */
export function transcriptText(lines: Line[]): string {
  return lines.map((l) => l.text.trim()).filter(Boolean).join(' ');
}
